import RequestService from "../../services/RequestService";
import FormBase from "../FormBase";
import FormFieldBase from "../../forms/FormFieldBase";
import ValidationBase, { ValidationType } from "../../forms/ValidationBase";
import Professional from '../../models/Professional'
import { RegiaoOptions } from "../../data/Regiao";
import { TipoCadastroMultiprofissionalOptions } from "../../data/TipoCadastroMultiprofissional";


export default class PersonalAddressDataForm implements FormBase {

    TypeRegistration: FormFieldBase;
    Region: FormFieldBase;

    constructor(typeRegistration: any, region: string) {
        this.TypeRegistration = new FormFieldBase(typeRegistration, [new ValidationBase("", ValidationType.OBRIGATORIO)]);
        this.Region = new FormFieldBase(region, [new ValidationBase("", ValidationType.OBRIGATORIO)]);
    }

    static NewInstance(): PersonalAddressDataForm {
        return new PersonalAddressDataForm("", "");
    }

    async CallInsertOrUpdateApi(Professional: Professional): Promise<any> {
        const dataJson = this.getJsonObjet();
        return RequestService.postCreateOrUpdateRequest(dataJson, Professional.Id);
    }

    ValidateToGoNextStep(): string {
        let propNames = Object.getOwnPropertyNames(this);

        let formIsValid = true;

        for (let index = 0; index < propNames.length; index++) {
            const element = propNames[index];
            const error = this.GetFieldByName(element).ValidateField();

            if (error !== null && error !== "") {
                formIsValid = false;
            }
        }

        if (!formIsValid) {
            return "Por favor, preencha os dados obrigatórios."
        } else {
            return "";
        }
    }

    GetFieldByName(name: string): FormFieldBase {

        switch (name) {

            case "TypeRegistration":
                return this.TypeRegistration

            case "Region":
                return this.Region

            default:
                return new FormFieldBase("", []);
        }
    }

    getSpecialty(): string {
        return TipoCadastroMultiprofissionalOptions.find(r => r.value === this.TypeRegistration.Value)?.text || "";
    }

    getJsonObjet() {

        return {
            "ProfessionalId": 0,
            "RequestTypeRegistration": {
                "Id": TipoCadastroMultiprofissionalOptions.find(r => r.value === this.TypeRegistration.Value)?.id,
                "Name": TipoCadastroMultiprofissionalOptions.find(r => r.value === this.TypeRegistration.Value)?.text
            },
            "RequestType": {
                "Id": 4,
                "Name": 'Cadastro Multiprofissional'
            },
            "RequestRegion": RegiaoOptions.find(r => r.value === this.Region.Value)?.id,
        }
    }

}